import { seededRandom } from './random';

export const FIELD_R = 120;
export const REST_RADIUS = 3;

export type FollicleSlot = { x: number; y: number; size: number };
export type StromaDot = { x: number; y: number; r: number };

const rand = seededRandom(23);

function buildSlots(count: number): FollicleSlot[] {
  const pool: FollicleSlot[] = [];
  let tries = 0;
  while (pool.length < count && tries < 30000) {
    tries++;
    const x = (rand() * 2 - 1) * FIELD_R * 0.82;
    const y = (rand() * 2 - 1) * FIELD_R * 0.82;
    if (Math.hypot(x, y) > FIELD_R * 0.82) continue;
    if (pool.some((s) => Math.hypot(s.x - x, s.y - y) < 27)) continue;
    pool.push({ x, y, size: 0.75 + rand() * 0.3 });
  }
  // Farthest-point ordering so the first follicles to grow are spread across the field.
  const ordered: FollicleSlot[] = [pool.splice(0, 1)[0]];
  while (pool.length) {
    let best = 0;
    let bestD = -1;
    pool.forEach((p, i) => {
      const d = Math.min(...ordered.map((o) => Math.hypot(o.x - p.x, o.y - p.y)));
      if (d > bestD) {
        bestD = d;
        best = i;
      }
    });
    ordered.push(pool.splice(best, 1)[0]);
  }
  return ordered;
}

function buildStroma(count: number): StromaDot[] {
  const dots: StromaDot[] = [];
  while (dots.length < count) {
    const x = (rand() * 2 - 1) * FIELD_R;
    const y = (rand() * 2 - 1) * FIELD_R;
    if (Math.hypot(x, y) < FIELD_R * 0.94) dots.push({ x, y, r: 0.5 + rand() * 0.7 });
  }
  return dots;
}

export const FOLLICLE_SLOTS = buildSlots(34);
export const STROMA_DOTS = buildStroma(90);

export function follicleRadius(i: number, n: number): number {
  const g = Math.min(1, Math.max(0, n - i));
  const crowd = Math.min(1, Math.max(0, (n - 14) / 14));
  const rMax = (15 - 4 * crowd) * FOLLICLE_SLOTS[i].size;
  return REST_RADIUS + (rMax - REST_RADIUS) * g;
}
